import { checkProductLimit } from "../../utils/planLimits";
import PlanLimitBanner from "../../components/ui/PlanLimitBanner";
import QuickAddWarehouseManager from "../../components/ui/QuickAddWarehouseManager";
import {
  // getAllCategories,
  getAllBrands,
  getAllWarehousesManager,
  getAllFamilies,
  getAllSubFamiliesByFamilyId,
  getAllCategoriesBySubFamilyId,
} from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import AddBrand from "../../ui/AddBrand";
// import { addNewProduct } from "../../reduxSaga/actions";
// import { BlockPicker } from "react-color";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useRef, useState } from "react";
import AddCategory from "../../ui/AddCategory";
import AddFamily from "../../ui/AddFamily";
import AddSubFamily from "../../ui/AddSubFamily";
import ConfirmAddProduct from "../../ui/ConfirmAddProduct";
import { Alert } from "@material-ui/lab";
import { Checkbox, Snackbar } from "@mui/material";
import "./AddProductStyle.css";
// import $ from "jquery";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import WarehouseService from "../../services/WarehouseService";
import SellingService from "../../services/SellingService";
import ProductPurchaseService from "../../services/ProductPurchaseService";
import { useNavigate } from "react-router-dom";
import UtilsFormule from "../../utils/UtilsFormule";

const currencyOptions = [
  { value: "TND", label: "DNT" },
  { value: "EUR", label: "Euro" },
  { value: "USD", label: "US Dollar" },
  { value: "SAR", label: "Saudi Riyal" },
  { value: "AED", label: "United Arab Emirates Dirham" },
  { value: "CAD", label: "Canadian Dollar" },
  { value: "CNY", label: "Chinese Yuan" },
];

// le backend renvoie soit l'objet créé, soit son id
const extractId = (value) => {
  if (value && typeof value === "object") {
    return value.id ?? value.idProduct ?? value.idWarehouse ?? null;
  }
  return /^\d+$/.test(String(value)) ? Number(value) : null;
};

const AddProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const availableProduct = useSelector((state) => state.staff.availableProduct);
  const animatedComponents = makeAnimated();

  const availableBrands = useSelector((state) => state.staff.availableBrands);
  const availableFamilies = useSelector(
    (state) => state.staff.availableFamilies
  );
  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );

  const availableCategories = useSelector(
    (state) => state.staff.availableCategories
  );

  const [brandId, setBrandId] = useState();
  const [allBrands, setAllBrands] = useState([]);
  const [brandSelectPlaceHolder, setBrandSelectPlaceHolder] =
    useState("Choisir une marque");
  const [familySelectPlaceHolder, setFamilySelectPlaceHolder] = useState(
    "Choisir une famille de produits"
  );
  const [subFamilySelectPlaceHolder, setSubFamilySelectPlaceHolder] = useState(
    "Choisir une sous famille de produits"
  );
  const [categorySelectPlaceHolder, setCategorySelectPlaceHolder] = useState(
    "Choisir une catégorie de produits"
  );
  // const [libelleColor, setLibelleColor] = useState("");
  // const [background, setBackground] = useState("#FF5733");

  const [productName, setProductName] = useState("");
  const [productBarCode, setProductBarCode] = useState("");
  const [productCodeArticle, setProductCodeArticle] = useState("");

  const [productInitialPrice, setProductInitialPrice] = useState(0);
  const [productMinStock, setProductMinStock] = useState(0);
  const [productDesc, setProductDesc] = useState("");
  const [productTva, setCategoryTva] = useState(0);
  const [familyId, setFamilyId] = useState(0);
  const [familyName, setFamilyName] = useState(null);
  const [allFamilly, setAllFamilly] = useState([]);
  const [allSubFamilies, setAllSubFamilies] = useState([]);
  const [allCategories, setAllCategories] = useState([]);

  const [categorieSellingPrice, setCategorySellingPrice] = useState(0);
  const [subFamilyName, setSubFamilyName] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const [categoryId, setCategoryId] = useState(0);
  const [subFamilyId, setSubFamilyId] = useState(0);
  const [onAddBrand, setOnAddBrand] = useState(false);
  const [onAddCategory, setOnAddCategory] = useState(false);
  const [onAddFamily, setOnAddFamily] = useState(false);
  const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [onConfirmAddProduct, setOnConfirmAddProduct] = useState(false);
  const [confirmProductModel, setConfirmProductModel] = useState();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [myProductModel, setMyProductModel] = useState({});
  const [typeCategory, setTypeCategory] = useState(0);

  // radio bouton
  const [onSale, setOnSale] = useState(0);
  const [onPurchase, setOnPurchase] = useState(0);
  const [finalProduct, setFinalProduct] = useState(0);
  const [rawMaterial, setRawMaterial] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [typeFamily, setTypeFamily] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionFamily, setSelectedOptionFamily] = useState(null);
  const [selectedOptionSubFamily, setSelectedOptionSubFamily] = useState(null);
  const [selectedOptionCategory, setSelectedOptionCategory] = useState(null);
  const [listSkus, setListSkus] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [submitStep, setSubmitStep] = useState("");
  // ids déjà créés : permet de reprendre après un échec partiel sans doublon
  const progress = useRef({});

  // prix et stock initial (facultatifs)
  const [purchasePrice, setPurchasePrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [initialQuantity, setInitialQuantity] = useState("");
  // nouveau dépôt (créé via addWarehouse) pour le stock initial
  const [warehouseMode, setWarehouseMode] = useState("existing"); // existing | new
  const [existingWarehouse, setExistingWarehouse] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [newWarehouseName, setNewWarehouseName] = useState("");
  const [newWarehouseRef, setNewWarehouseRef] = useState("");
  const [newWarehouseAddress, setNewWarehouseAddress] = useState("");
  const [newWarehouseDevise, setNewWarehouseDevise] = useState(currencyOptions[0]);
  const [newWarehouseManager, setNewWarehouseManager] = useState(null);
  const warehousesManager = useSelector(
    (state) => state.staff.warehousesManager?.success
  );
  // managers created from this page are shown at once, before the list is reloaded
  const [createdManagers, setCreatedManagers] = useState([]);
  const [showQuickManager, setShowQuickManager] = useState(false);
  const managerOptions = [
    ...(warehousesManager || []).map((m) => ({
      value: m.id,
      label: m.firstName + " " + m.lastName,
    })),
    ...createdManagers,
  ].filter((o, i, all) => all.findIndex((x) => x.value === o.value) === i);
  const onManagerCreated = (manager) => {
    const option = { value: manager.id, label: manager.firstName + " " + manager.lastName };
    setCreatedManagers((old) => [...old, option]);
    setNewWarehouseManager(option);
    dispatch(getAllWarehousesManager());
  };

  useEffect(() => {
    dispatch(getAllFamilies(0));
    // console.log(getAllFamilies(0));
    dispatch(getAllBrands(0));
    dispatch(getAllWarehousesManager());
    WarehouseService.getAllRealWarehouseForPrice(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehouseOptions(
            response.data.success
              .filter((w) => w && w.id !== undefined)
              .map((w) => ({ value: w.id, label: w.name, devise: w.devise }))
          );
        }
      })
      .catch((e) => console.log("error in getAllRealWarehouse", e));
  }, []);

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
      zIndex: 9999,
    }),
  };
  const styles2 = {
    container: (base) => ({
      ...base,
      flex: 1,
      // zIndex: 9999
    }),
  };

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  useEffect(() => {
    setAllFamilly([]);
    availableFamilies &&
      availableFamilies.map((element, i) => {
        if (i === 0) {
          setFamilyId(element.id);
          setTypeFamily(element.type);
        }
        setAllFamilly((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableFamilies]);

  useEffect(() => {
    familyId && dispatch(getAllSubFamiliesByFamilyId(familyId));
  }, [familyId]);

  useEffect(() => {
    if (availableSubFamilies.length === 0) {
      setSubFamilyId(0);
      setCategoryId(0);
    }
    setAllSubFamilies([]);

    availableSubFamilies &&
      availableSubFamilies.map((element, i) => {
        if (i === 0) {
          setSubFamilyId(element.id);
        }
        setAllSubFamilies((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            // customElements: element.type,
          },
        ]);
      });
  }, [availableSubFamilies]);

  useEffect(() => {
    subFamilyId && dispatch(getAllCategoriesBySubFamilyId(subFamilyId));
  }, [subFamilyId]);

  useEffect(() => {
    console.log("availableCategories", availableCategories);

    if (availableCategories === undefined || availableCategories.length === 0) {
      setCategoryId(0);
    }
    setAllCategories([]);
    availableCategories &&
      availableCategories.map((element, i) => {
        if (i === 0) {
          setCategoryId(element.id);
          setTypeCategory(element.type);
        }
        setAllCategories((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableCategories]);

  useEffect(() => {
    setAllBrands([]);
    availableBrands &&
      availableBrands.map((element, i) => {
        if (i === 0) {
          setBrandId(element.id);
        }
        setAllBrands((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.name },
        ]);
      });
  }, [availableBrands]);

  const onChangeNameHandler = (event) => {
    setProductName(event.target.value);
  };

  const onChangeSelectedBrand = (selectedOptionn) => {
    setSelectedOption();
    setBrandId(selectedOptionn.value);
    setBrandSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedFamily = (selectedOption) => {
    console.log("family", selectedOption);
    setSelectedOptionFamily();
    setFamilyId(selectedOption.value);
    setFamilySelectPlaceHolder(selectedOption.label);
    setTypeFamily(selectedOption.customElements);
  };
  const onChangeSelectedSubFamily = (selectedOption) => {
    setSelectedOptionSubFamily();
    setSubFamilyId(selectedOption.value);
    setSubFamilySelectPlaceHolder(selectedOption.label);
    // setTypeFamily(selectedOption.customElements);
  };
  const onChangeSelectedCategory = (selectedOption) => {
    setSelectedOptionCategory();
    setCategoryId(selectedOption.value);
    setCategorySelectPlaceHolder(selectedOption.label);
    setTypeCategory(selectedOption.customElements);
  };

  const onChangeBarCodeHandler = (event) => {
    setProductBarCode(event.target.value);
  };
  const onChangeCodeArticleHandler = (event) => {
    // if (typeFamily !== "2") {
    setProductCodeArticle(event.target.value);
    // }
  };

  // const onChangeDescriptionHandler = (event) => {
  //   setProductDesc(event.target.value);
  // };

  const onChangeTvaHandler = (event) => {
    setCategoryTva(event.target.value);
    if (productInitialPrice !== 0 && productTva !== 0) {
      let opOne =
        (parseInt(productInitialPrice) / 100) * parseInt(event.target.value);
      let opTwo = parseInt(productInitialPrice) + opOne;

      setCategorySellingPrice(opTwo);
    } else setCategorySellingPrice(0);
  };
  const onAddBrandHandler = () => {
    setOnAddBrand(true);
  };

  // const onAddSubFamilyHandler = () => {
  //   setOnAddSubFamily(true);
  // };

  // const onAddCategorieHandler = () => {
  //   setOnAddCategory(true);
  // };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  // ---- enregistrement : une étape par appel API, reprise possible en cas d'échec partiel ----
  const wantsStock = Number(initialQuantity) > 0;
  const wantsSellingPrice = sellingPrice !== "";
  const wantsPurchasePrice = purchasePrice !== "";
  const needsWarehouse = wantsStock || wantsSellingPrice;
  const warehouseReady =
    warehouseMode === "existing"
      ? !!existingWarehouse
      : newWarehouseName.trim() !== "" &&
        newWarehouseRef.trim() !== "" &&
        newWarehouseAddress.trim() !== "" &&
        !!newWarehouseManager;

  const showError = (text) => {
    setErrorAlertText(text);
    setOpenErrorAlert(true);
  };

  const validateForm = () => {
    if (productName.trim() === "") return "Le libellé est obligatoire.";
    if (familyId === 0) return "La famille est obligatoire.";
    if (subFamilyId === 0) return "La sous famille est obligatoire.";
    if (categoryId === 0) return "La catégorie est obligatoire.";
    if (
      (wantsPurchasePrice && Number(purchasePrice) < 0) ||
      (wantsSellingPrice && Number(sellingPrice) < 0) ||
      (initialQuantity !== "" && Number(initialQuantity) < 0)
    ) {
      return "Les prix et la quantité doivent être positifs.";
    }
    if (needsWarehouse && !warehouseReady) {
      return warehouseMode === "existing"
        ? "Choisissez un dépôt pour le stock initial / prix de vente."
        : "Renseignez le nouveau dépôt (nom, référence, adresse, responsable).";
    }
    return null;
  };

  const onConfirmAddProductHandler = async () => {
    if (submitting) return;
    const validationError = validateForm();
    if (validationError) {
      showError(validationError);
      return;
    }
    const idUser = getCurrentUserId();
    const p = progress.current;
    setSubmitting(true);
    let currentStep = "";
    try {
      // 1) produit : POST /product/addProduct
      if (!p.idProduct) {
        const limit = await checkProductLimit(1);
        if (!limit.allowed) {
          showError(limit.message);
          return;
        }
        currentStep = "la création du produit";
        setSubmitStep("Création du produit…");
        const result = await ProductService.addNewProduct({
          name: productName.trim(),
          idBrand: brandId,
          idProductCategory: categoryId,
          idProductFamily: familyId,
          idProductSubFamily: subFamilyId,
          idUserCreation: idUser,
          minimumQuantity: productMinStock,
          productCode: productCodeArticle,
          barcode: productBarCode,
          familyName: familyName,
          subFamilyName: subFamilyName,
          categoryName: categoryName,
          tva: productTva,
          onSale: onSale,
          onPurchase: onPurchase,
          endProduct: finalProduct,
          rawMatrial: rawMaterial,
        });
        p.idProduct = extractId(result.data["success"]);
        if (!p.idProduct) {
          showError("Erreur : le produit n'a pas été créé.");
          return;
        }
      }

      // 2) dépôt : existant, ou POST /warehouse/addWarehouse
      if (needsWarehouse && !p.idWarehouse) {
        if (warehouseMode === "existing") {
          p.idWarehouse = existingWarehouse.value;
          p.whName = existingWarehouse.label;
          p.whDevise = existingWarehouse.devise || "TND";
        } else {
          currentStep = "la création du dépôt";
          setSubmitStep("Création du dépôt…");
          const whResult = await WarehouseService.addWarehouse({
            name: newWarehouseName.trim(),
            ref: newWarehouseRef.trim(),
            listManagers: [newWarehouseManager.value],
            idUser: idUser,
            description: "",
            address: newWarehouseAddress.trim(),
            devise: newWarehouseDevise.value,
            deviseName: newWarehouseDevise.label,
            vitualWarehouse: 0,
            priceWarehouse: 0,
          });
          p.idWarehouse = extractId(whResult.data["success"]);
          if (!p.idWarehouse) {
            showError("Erreur : le dépôt n'a pas été créé.");
            return;
          }
          p.whName = newWarehouseName.trim();
          p.whDevise = newWarehouseDevise.value;
        }
      }

      // 3) stock : /warehouse/addProductToWarehouse/{idUser}/{idWarehouse}/{idProduct}/{qte}
      if (wantsStock && !p.stockDone) {
        currentStep = "l'ajout au dépôt";
        setSubmitStep("Ajout du produit au dépôt…");
        await WarehouseService.addProductToWarehouse(
          idUser,
          p.idWarehouse,
          p.idProduct,
          Number(initialQuantity)
        );
        p.stockDone = true;
      }

      // 4) prix d'achat : POST /productPurchase/createProductPurchase/{idUser}/{idProduct}
      if (wantsPurchasePrice && !p.purchaseDone) {
        currentStep = "l'enregistrement du prix d'achat";
        setSubmitStep("Enregistrement du prix d'achat…");
        await ProductPurchaseService.createProductPurchase(idUser, p.idProduct, {
          price: Number(purchasePrice),
          qte: wantsStock ? Number(initialQuantity) : 0,
          ...(p.idWarehouse && { idWarehouse: p.idWarehouse }),
        });
        p.purchaseDone = true;
      }

      // 5) prix de vente : POST /SellingPrice/setSellingPrice
      if (wantsSellingPrice && !p.sellingDone) {
        currentStep = "l'enregistrement du prix de vente";
        setSubmitStep("Enregistrement du prix de vente…");
        await SellingService.setSellingPrice({
          idProduct: p.idProduct,
          idUser: idUser,
          productWarehousePrices: [
            {
              warehouseId: p.idWarehouse,
              warehouseName: p.whName,
              value: Number(sellingPrice),
              devise: p.whDevise,
            },
          ],
        });
        p.sellingDone = true;
      }

      setSuccessAlertText("Produit enregistré avec succès");
      setOpenSuccessAlert(true);
      setTimeout(() => navigate(`/products`), 1500);
    } catch (e) {
      console.log("error", e);
      showError(
        p.idProduct
          ? `Le produit est créé mais ${currentStep} a échoué. Cliquez sur « Enregistrer » pour reprendre à cette étape.`
          : "Erreur serveur : le produit n'a pas été créé."
      );
    } finally {
      setSubmitting(false);
      setSubmitStep("");
    }
  };

  const onchooseOnSaleHandler = () => setOnSale(onSale ? 0 : 1);
  const onchooseOnPurchaseHandler = () => setOnPurchase(onPurchase ? 0 : 1);
  const onchooseFinalProductHandler = () =>
    setFinalProduct(finalProduct ? 0 : 1);
  const onchooseRawMaterialHandler = () => setRawMaterial(rawMaterial ? 0 : 1);
  const handleOnChangeCategory = (event) => {
    const selectedIndex = event.target.options.selectedIndex;
    let index =
      event.target.options[selectedIndex].getAttribute("indexOfElement");

    let category = availableCategories[index];
    setCategoryId(category.id);
    setTypeCategory(category.type);
  };
  const handleOnChangeFamily = (event) => {
    const selectedIndex = event.target.options.selectedIndex;
    let index = event.target.options[selectedIndex].getAttribute(
      "indexOfElementFamily"
    );
    let family = availableFamilies[index];
    console.log("family", family);

    setFamilyId(family.id);
    setTypeFamily(family.type);
    setSubFamilyName(null);
  };

  const blocProductOnSale = () => {
    if (typeCategory === 2 && typeFamily === "2") {
      return null;
    }
    const options = [
      { label: "En vente", checked: onSale, onChange: onchooseOnSaleHandler },
      { label: "En achat", checked: onPurchase, onChange: onchooseOnPurchaseHandler },
      { label: "Produit fini", checked: finalProduct, onChange: onchooseFinalProductHandler },
      { label: "Matière première", checked: rawMaterial, onChange: onchooseRawMaterialHandler },
    ];
    return (
      <div className="row">
        {options.map((o) => (
          <div className="col-sm-6 col-md-3" key={o.label}>
            <label
              className={`add-product-option ${o.checked ? "is-checked" : ""}`}
            >
              <Checkbox
                checked={o.checked === 1}
                onChange={o.onChange}
                style={{ color: "#14532d" }}
              />
              <span>{o.label}</span>
            </label>
          </div>
        ))}
      </div>
    );
  };
  const priceCurrency =
    warehouseMode === "new"
      ? newWarehouseDevise.value
      : existingWarehouse?.devise || "DT";
  const margin =
    purchasePrice !== "" && sellingPrice !== ""
      ? Number(sellingPrice) - Number(purchasePrice)
      : null;
  const marginPct =
    margin !== null && Number(purchasePrice) > 0
      ? (margin / Number(purchasePrice)) * 100
      : null;
  const summaryItems = [
    "Création du produit",
    ...(Number(initialQuantity) > 0 || sellingPrice !== ""
      ? [
          warehouseMode === "new"
            ? `Création du dépôt « ${newWarehouseName.trim() || "…"} »`
            : `Dépôt : ${existingWarehouse?.label || "à choisir"}`,
        ]
      : []),
    ...(Number(initialQuantity) > 0
      ? [`Ajout de ${initialQuantity} unité(s) en stock`]
      : []),
    ...(purchasePrice !== "" ? [`Prix d’achat : ${purchasePrice}`] : []),
    ...(sellingPrice !== "" ? [`Prix de vente : ${sellingPrice}`] : []),
  ];

  const addButtonSubFamily = () => {
    return (
      <button
        class="btn btn-dark"
        onClick={(e) => {
          navigate("/addSubFamily");
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  };
  const addButtonCategory = () => {
    return (
      <button
        class="btn btn-dark"
        onClick={(e) => {
          navigate("/addCategory");
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Produit</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <PlanLimitBanner kind="products" />
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark add-product-card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="fas fa-box-open mr-2"></i>Ajouter un produit
                  </h5>
                </div>
                <div className="card-body">
                  <h6 className="add-product-section">
                    <i className="fas fa-sitemap mr-2"></i>Classification
                  </h6>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Marque <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend" style={{ width: "90%" }}>
                            <Select
                              styles={styles}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={selectedOption}
                              onChange={onChangeSelectedBrand}
                              options={allBrands}
                              placeholder={brandSelectPlaceHolder}
                            />
                          </div>
                          <div className="input-group-append">
                            <button
                              className="btn btn-dark"
                              data-toggle="modal"
                              data-target="#add-brand"
                              onClick={onAddBrandHandler}
                            >
                              <i className="fas fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Famille <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          styles={styles}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionFamily}
                          onChange={onChangeSelectedFamily}
                          options={allFamilly}
                          placeholder={familySelectPlaceHolder}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Sous famille <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend" style={{ width: "90%" }}>
                            <Select
                              styles={styles2}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={selectedOptionSubFamily}
                              onChange={onChangeSelectedSubFamily}
                              autosize={false}
                              options={allSubFamilies}
                              placeholder={subFamilySelectPlaceHolder}
                            />
                          </div>
                          <div className="input-group-append">{addButtonSubFamily()}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Catégorie <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend" style={{ width: "90%" }}>
                            <Select
                              styles={styles2}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={selectedOptionCategory}
                              onChange={onChangeSelectedCategory}
                              autosize={false}
                              options={allCategories}
                              placeholder={categorySelectPlaceHolder}
                            />
                          </div>
                          <div className="input-group-append">{addButtonCategory()}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h6 className="add-product-section">
                    <i className="fas fa-info-circle mr-2"></i>Informations générales
                  </h6>
                  <div className="row">
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Libellé <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                          placeholder="Nom du produit"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputTva">TVA (%)</label>
                        <input
                          onChange={onChangeTvaHandler}
                          type="number"
                          min="0"
                          id="inputTva"
                          className="form-control"
                          placeholder="0"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputCodeArticle">Code article</label>
                        <input
                          onChange={onChangeCodeArticleHandler}
                          type="text"
                          id="inputCodeArticle"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputBarCode">Code à barre</label>
                        <input
                          onChange={onChangeBarCodeHandler}
                          type="text"
                          id="inputBarCode"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <h6 className="add-product-section">
                    <i className="fas fa-tags mr-2"></i>Type de produit
                  </h6>
                  {blocProductOnSale()}

                  <h6 className="add-product-section">
                    <i className="fas fa-warehouse mr-2"></i>Dépôt et stock initial{" "}
                    <small className="text-muted">(facultatif)</small>
                  </h6>
                  <p className="add-product-hint">
                    Renseignez un dépôt pour ajouter le produit en stock ou lui
                    donner un prix de vente.
                  </p>
                  <div className="btn-group mb-3" role="group">
                    <button
                      type="button"
                      className={`btn ${
                        warehouseMode === "existing" ? "btn-dark" : "btn-outline-dark"
                      }`}
                      onClick={() => setWarehouseMode("existing")}
                    >
                      <i className="fas fa-list mr-2"></i>Dépôt existant
                    </button>
                    <button
                      type="button"
                      className={`btn ${
                        warehouseMode === "new" ? "btn-dark" : "btn-outline-dark"
                      }`}
                      onClick={() => setWarehouseMode("new")}
                    >
                      <i className="fas fa-plus mr-2"></i>Nouveau dépôt
                    </button>
                  </div>
                  <div className="row">
                    {warehouseMode === "new" ? (
                      <>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label htmlFor="inputWhName">
                              Nom du dépôt <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              id="inputWhName"
                              type="text"
                              className="form-control"
                              value={newWarehouseName}
                              onChange={(e) => setNewWarehouseName(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label htmlFor="inputWhRef">
                              Référence <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              id="inputWhRef"
                              type="text"
                              className="form-control"
                              value={newWarehouseRef}
                              onChange={(e) => setNewWarehouseRef(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label htmlFor="inputWhAddress">
                              Adresse <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              id="inputWhAddress"
                              type="text"
                              className="form-control"
                              value={newWarehouseAddress}
                              onChange={(e) => setNewWarehouseAddress(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label>Devise</label>
                            <Select
                              styles={styles2}
                              options={currencyOptions}
                              value={newWarehouseDevise}
                              onChange={(o) => setNewWarehouseDevise(o)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              Responsable du dépôt <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="d-flex align-items-start">
                              <div style={{ flex: 1 }}>
                                <Select
                                  styles={styles2}
                                  options={managerOptions}
                                  value={newWarehouseManager}
                                  onChange={(o) => setNewWarehouseManager(o)}
                                  placeholder="Choisir un responsable"
                                  noOptionsMessage={() => "Aucun responsable"}
                                />
                              </div>
                              <button
                                type="button"
                                className="btn btn-outline-dark ml-2"
                                title="Ajouter un responsable de dépôt"
                                onClick={() => setShowQuickManager(true)}
                              >
                                <i className="fas fa-user-plus"></i>
                              </button>
                            </div>
                            {showQuickManager && (
                              <QuickAddWarehouseManager
                                onClose={() => setShowQuickManager(false)}
                                onCreated={onManagerCreated}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Dépôt</label>
                          <Select
                            styles={styles2}
                            isClearable
                            options={warehouseOptions}
                            value={existingWarehouse}
                            onChange={(o) => setExistingWarehouse(o)}
                            placeholder="Choisir un dépôt"
                            noOptionsMessage={() => "Aucun dépôt"}
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputQuantity">Quantité en stock</label>
                        <input
                          id="inputQuantity"
                          type="number"
                          min="0"
                          step="any"
                          className="form-control"
                          placeholder="0"
                          value={initialQuantity}
                          onChange={(e) => setInitialQuantity(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <h6 className="add-product-section">
                    <i className="fas fa-coins mr-2"></i>Prix{" "}
                    <small className="text-muted">(facultatif)</small>
                  </h6>
                  <div className="row">
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputPurchasePrice">Prix d’achat</label>
                        <div className="input-group">
                          <input
                            id="inputPurchasePrice"
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            placeholder="0.000"
                            value={purchasePrice}
                            onChange={(e) => setPurchasePrice(e.target.value)}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">{priceCurrency}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="inputSellingPrice">Prix de vente</label>
                        <div className="input-group">
                          <input
                            id="inputSellingPrice"
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            placeholder="0.000"
                            value={sellingPrice}
                            onChange={(e) => setSellingPrice(e.target.value)}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">{priceCurrency}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {margin !== null && (
                      <div className="col-md-12 col-lg-6 d-flex align-items-center">
                        <span
                          className={`badge ${
                            margin >= 0 ? "badge-success" : "badge-danger"
                          } add-product-margin`}
                        >
                          Marge : {margin.toFixed(3)} {priceCurrency}
                          {marginPct !== null && ` (${marginPct.toFixed(1)} %)`}
                        </span>
                      </div>
                    )}
                  </div>

                  {summaryItems.length > 0 && (
                    <div className="add-product-summary">
                      <strong>
                        <i className="fas fa-tasks mr-2"></i>Lors de
                        l’enregistrement :
                      </strong>
                      <ol>
                        {summaryItems.map((t) => (
                          <li key={t}>{t}</li>
                        ))}
                      </ol>
                    </div>
                  )}
                </div>
                <div className="card-footer">
                  <button
                    className="btn btn-outline-dark mr-2"
                    disabled={submitting}
                    onClick={() => navigate("/products")}
                  >
                    Annuler
                  </button>
                  <button
                    className="btn btn-dark float-right"
                    disabled={submitting}
                    onClick={onConfirmAddProductHandler}
                  >
                    {submitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-2"></span>
                        {submitStep || "Enregistrement…"}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-check mr-2"></i>Enregistrer
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="col-sm-10"> </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>

      {onAddSubFamily && (
        <AddSubFamily
          familyId={familyId}
          setOnAddSubFamily={setOnAddSubFamily}
        />
      )}
      {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />}
      {onAddBrand && <AddBrand setOnAddBrand={setOnAddBrand} />}
      {onAddCategory && (
        <AddCategory
          familyId={familyId}
          subFamilyId={subFamilyId}
          setOnAddCategory={setOnAddCategory}
        />
      )}
      {onConfirmAddProduct && (
        <ConfirmAddProduct
          setOnConfirmAddProduct={setOnConfirmAddProduct}
          confirmProductModel={confirmProductModel}
          setMyProductModel={setMyProductModel}
        />
      )}
    </div>
  );
};
export default AddProduct;
